import { c as _c } from "react/compiler-runtime";
import { VStack } from '@chakra-ui/react';
import { SidebarCollapsingNavList } from '@src/components/sco/SidebarCollpasingNavList';
import { ToolsNavList } from '@src/components/sco/Tools/ToolsNavList.tsx';
import React from 'react';
import { LuHammer, LuMessageCircleCode, LuPencilRuler } from 'react-icons/lu';
export const ToolsNav = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <VStack align="stretch" gap={2} height="full" width="full"><SidebarCollapsingNavList collapsed={true} items={[{
        icon: LuHammer,
        href: "/tools",
        title: "All Tools",
        activeExact: true
      }, {
        icon: LuPencilRuler,
        href: "/tools/apps",
        title: "App Tools",
        activeExact: true
      }, {
        icon: LuMessageCircleCode,
        href: "/tools/chat",
        title: "Chat Tools",
        activeExact: true
      }, {
        icon: LuMessageCircleCode,
        href: "/tools/chat/sessions",
        title: "Chat Tool Sessions",
        activeExact: true
      }]} /><ToolsNavList /></VStack>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};